module.exports = __webpack_public_path__ + "img/40_38_062_260.5cc1738d.jpg";